import React from "react";
import { ArrowRight, Droplets, Ruler, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrecisionWetRooms() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    icon: <Ruler className="w-5 h-5" />,
    text: "Precision sloped floors for perfect drainage"
  }, {
    icon: <Droplets className="w-5 h-5" />,
    text: "Hidden linear drains & seamless integration"
  }, {
    icon: <ShieldCheck className="w-5 h-5" />,
    text: "Complete waterproof tanking systems"
  }];
  return <section id="precision-wet-rooms" ref={sectionRef} className="bg-background text-black py-24 lg:py-32 overflow-hidden relative">
      <div className="container ml-0 mr-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className={`lg:col-span-7 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-sm overflow-hidden shadow-2xl">
              <AspectRatio ratio={4 / 3} className="bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1571404/img/walk_in_shower_linear_drain.png" alt="Luxury walk-in shower with hidden linear drain and level access flooring" className="object-cover w-full h-full hover:scale-105 transition-transform duration-700" />
              </AspectRatio>
              <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-primary/10 -z-10 rounded-full blur-2xl" />
            </div>
          </div>

          <div className="flex flex-col justify-start transition-all duration-1000 delay-300 ease-out opacity-100 translate-x-0 !text-[hsl(0,0%,0%)] lg:col-span-5 lg:pl-16 xl:pl-24">
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold tracking-tight mb-6 !text-[hsl(0,0%,0%)] md:text-4xl lg:text-5xl">
                  Level Access <br />
                  <span className="text-black/80 font-light">Perfection</span>
                </h2>
                <p className="text-lg leading-relaxed border-l-2 border-primary/20 pl-6 !text-[hsl(0,0%,0%)]">
                  Experience the ultimate in modern bathroom design with our
                  specialist wet room installations. We focus on creating true
                  level-access showers where form meets function.
                </p>
              </div>

              <div className="space-y-4 pl-6">
                {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-4 group">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-secondary/10 flex items-center justify-center text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                      {feature.icon}
                    </div>
                    <span className="font-medium !text-[hsl(0,0%,0%)]">
                      {feature.text}
                    </span>
                  </div>)}
              </div>

              <div className="pt-4 pl-6">
                <Button asChild size="lg" className="group">
                  <Link to="#">
                    Get a Free Quote
                    <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}